import { Injectable } from '@angular/core';
import { Observable, Subscription, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChildLoadingService {
  /** Subject to check for loading status*/
  loading$ = new BehaviorSubject<boolean>(true);
  constructor() {}
  /** trigger loading status update to loading */
  startLoading() {
    this.loading$.next(true);
  }
  /** trigger loading status update to not loading */
  endLoading() {
    this.loading$.next(false);
  }
}
